import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function StraightenIcon(props: IconProps) {
    return <Icon {...props} iconKey={"straighten"}/>
}
